import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { SimpleCheckbox } from 'components/Checkboxes';
import NumberInput from 'components/NumberInput';

import Text from '../../../../components/Text';

import InfoTooltip from '../../../../components/InfoTooltip';
import Status from './components/Status';
import { CheckboxWrapper, InputWrapper, MainWrapper, TextGroup, TextHeading } from './styles';

const platformsConfig = {
  kick: {
    name: 'Kick',
    bitsName: 'kicksy',
    activityKey: 'kickActivity',
    idKey: 'kick_id',
    inputs: [{ label: 'SUBSKRYBCJA', name: 'subKick' }, { label: '100 KICKSÓW', name: 'kicks' }],
  },
  twitch: {
    name: 'Twitch',
    bitsName: 'bitsy',
    activityKey: 'twitchActivity',
    idKey: 'twitch_id',
    inputs: [
      { label: 'SUB TIER 1', name: 'subTier1' },
      { label: 'SUB TIER 2', name: 'subTier2' },
      { label: 'SUB TIER 3', name: 'subTier3' },
      { label: '100 BITSÓW', name: 'subBits' },
    ],
  },
};

const Activity = ({
  platform,
  configuratorConfig,
  updateConfig,
  userData,
  dispatchSubscribe,
  dispatchUnsubscribe,
}) => {
  const [loading, setLoading] = useState(false);
  const { name, bitsName, activityKey, idKey, inputs } = platformsConfig[platform];
  const platformId = userData.info[idKey];

  const mainWrapperRef = useRef();
  const statusPortalContainerRef = useRef(document.createElement('div'));

  useEffect(() => {
    if (mainWrapperRef.current) {
      mainWrapperRef.current.parentNode.parentNode.prepend(statusPortalContainerRef.current);
    }
  }, [mainWrapperRef, statusPortalContainerRef]);

  const isConnected = platformId && platformId.length > 0;
  const subscriptionActivated = configuratorConfig[activityKey] || false;

  return (
    <MainWrapper ref={mainWrapperRef}>
      <Status
        targetEl={statusPortalContainerRef.current}
        connected={isConnected}
        platform={platform}
      />

      <TextGroup>
        <TextHeading>
          Ustal czas
          <InfoTooltip
            content={
              <>
                <Text>
                  W tym miejscu musisz podać ilość czasu w sekundach, która zostanie dodana do
                  odlicznika w momencie kiedy na Twoim kanale Kick lub Twitch otrzymasz subskrypcję
                  bądź bitsa/kicksa.
                </Text>
                <Text>
                  Uwaga: W przypadku klasycznych subskrypcji Twitch, czas doliczany jest w momencie
                  odnowienia subskrypcji np. przez pobranie płatności z konta bankowego, a nie w
                  momencie wyemitowania na czacie &quot;komunikatu&quot; o przedłużeniu subskrypcji
                  na życzenie Widza, co może zrobić po wejściu na czat na Twitchu.
                </Text>
              </>
            }
            placement="right"
            theme="dark"
          />
        </TextHeading>
        <div>{`jaki zostanie dodany za suby i ${bitsName} od widzów na Twoim kanale ${name}`}</div>
      </TextGroup>

      <CheckboxWrapper isConnected={isConnected} isActive={subscriptionActivated}>
        {!isConnected && `By włączyć funkcję połącz konto ${name} powyżej`}
        {isConnected &&
          !subscriptionActivated &&
          `Kliknij, aby włączyć subskrybcje eventów z ${name}`}
        {isConnected && subscriptionActivated && `Funkcja włączona`}

        <SimpleCheckbox
          name={activityKey}
          checked={configuratorConfig[activityKey] || false}
          color="green"
          apperance="switch"
          onCheck={async () => {
            setLoading(true);
            // TODO Nie możemy aktualizować updateConfig w taki sposób.
            //  OLD: updateConfig({ [activityKey]: value, [`${activityKey}Begin`]: moment().format() });
            //  To backend powinien aktualizować stan w zakeżności od response.
            if (!configuratorConfig[activityKey]) {
              await dispatchSubscribe();
            } else {
              // TODO Dlaczego dla Twitch był przekazany `{"broadcaster_user_id":"${id}"}` | To nic nie robiło...
              // src/pages/Configurators/components/TwitchActivity/index.jsx (deleted)
              //  const unsubscribeTwitch = `{"broadcaster_user_id":"${twitchId}"}`;
              //  dispatchTwitchUnsubscribe(unsubscribeTwitch);
              await dispatchUnsubscribe();
            }
            setLoading(false);
          }}
          disabled={!platformId || loading}
        />
      </CheckboxWrapper>

      {inputs.map(input => (
        <InputWrapper key={input.name}>
          <span>{input.label}</span>
          <NumberInput
            name={input.name}
            decimalSeparator=","
            defaultValue={configuratorConfig[input.name] || 0}
            decimalScale={0}
            allowEmptyFormatting
            allowNegative={false}
            suffix=" sek"
            onValueChange={value => updateConfig({ [input.name]: value.value })}
          />
        </InputWrapper>
      ))}

      <div className="additional-info">Dane podane w tym miejscu są zapisywane automatycznie</div>
    </MainWrapper>
  );
};

Activity.propTypes = {
  platform: PropTypes.oneOf(['kick', 'twitch']).isRequired,
  configuratorConfig: PropTypes.instanceOf(Object).isRequired,
  updateConfig: PropTypes.instanceOf(Function).isRequired,
  userData: PropTypes.instanceOf(Object).isRequired,
  dispatchSubscribe: PropTypes.instanceOf(Function).isRequired,
  dispatchUnsubscribe: PropTypes.instanceOf(Function).isRequired,
};

export default Activity;
